<div
  class="d-flex justify-content-center align-items-center"
  style="height: 50vh"
  *ngIf="isLoading"
>
  <div class="spinner-border d-flex" role="status">
    <span class="sr-only"></span>
  </div>
</div>